import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    email: translate({ id: 'sendMessageToDriverModal.messageType.email' }),
    messageType: translate({ id: 'sendMessageToDriverModal.messageType' }),
  }))

  return api
}
